import React from 'react';
import styled from 'styled-components';

interface SelectFilterProps {
    options: string[];
    value: string;
    onChange: (value: string) => void;
    defaultValue?: string;
    testId?: string;
}

const SelectFilter: React.FC<SelectFilterProps> = ({
    options,
    value,
    onChange,
    defaultValue,
    testId = 'select-filter',
}) => {
    return (
        <Select
            data-testid={testId}
            value={value || defaultValue || options[0]}
            onChange={e => onChange(e.target.value)}
        >
            {options.map(option => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
        </Select>
    );
};

const Select = styled.select`
    padding: 0.3rem 0.5rem;
    border-radius: 0.4rem;
    border: 0.1rem solid ${props => props.theme.colors.border};
    background: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.text.primary};
    font-size: ${props => props.theme.text.size.small};
    font-family: ${props => props.theme.text.font.regular};
    cursor: pointer;
    outline: none;

    &:focus {
        border-color: ${props => props.theme.colors.primary};
    }
`;

export default SelectFilter;
